module.exports = "/_next/static/images/sunlight-logo-54903ae268e0378b5a2dc33fee656d9b.svg";